import { Box, Button, Container, Grid, IconButton } from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import MRTTable from "src/components/mrt-table";
import useSettings from "src/hooks/useSettings";
import { masterGetData } from "src/pages/api";
import { PATH_DASHBOARD } from "src/routes/paths";
import { HOST_API } from "src/config-prod";
import DeleteRecord from "src/pages/master/DeleteRecord";
import AddThirdParty from "./Add";
// import DeleteRecord from "../../DeleteRecord";
const columns = [
  {
    accessorKey: "schoolName",
    header: "School Name",
  },
  {
    accessorKey: "fullName",
    header: "Name",
  },
  {
    accessorKey: "mobile",
    header: "Mobile No.",
  },
];

export default function ThirdParty() {
  const { themeStretch } = useSettings();
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading } = useQuery({
    queryKey: ["getData", "third_party", pagination.pageIndex, pagination.pageSize],
    queryFn: masterGetData,
  });

  return (
    <>
      {open && (
        <AddThirdParty
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
            setIsEditMode(false);
          }}
          row={selectedRow}
          isEditMode={isEditMode}
        />
      )}

      {openDelete && (
        <DeleteRecord
          row={{ ...selectedRow, name: selectedRow.fullName }}
          onClose={() => {
            setOpenDelete(false);
          }}
          tabeName={"third_party"}
        />
      )}
      <Page title="Courier">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <HeaderBreadcrumbs
            heading={`Third Party`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Courier",
              },
              { name: "Third Party" },
            ]}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <MRTTable
                data={data?.data || []}
                columns={columns}
                loading={isLoading}
                manualPagination={true}
                pagination={pagination}
                rowCount={data?.count || 0}
                onPaginationChange={setPagination}
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex" }}>
                    <IconButton
                      id ="editbtn"
                      onClick={() => {
                        setOpen(true);
                        setSelectedRow(row.original);
                        setIsEditMode(true);
                      }}
                      color="primary"
                    >
                      <Iconify icon={"eva:edit-fill"} />
                    </IconButton>
                    <IconButton
                      id ="deletebtn"
                      onClick={() => {
                        setOpenDelete(true);
                        setSelectedRow(row.original);
                      }}
                      color="error"
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton>
                  </Box>
                )}
                renderTopToolbarCustomActions={() => (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(true);
                      setIsEditMode(false);
                    }}
                  >
                    Add New
                  </Button>
                )}
              />
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
